import { Link } from 'react-router-dom'

import { Box } from '@components/Box'
import { EyeIcon } from '@components/Icons'
import { Table } from '@components/Table'
import { SortingType } from '@components/Table/interface'
import { OrderByEnum } from '@interfaces/dashboard/WriterParam'
import { NoData } from '@components/NoData'
import { WriterProps } from './interface'

export function Writer({
  data,
  isLoading,
  handleSortChange,
  handleWaypointEnter,
}: WriterProps) {
  const items = data?.pages.flatMap(row => row?.data) || []

  return (
    <>
      <Box.Title>การค้นหาโดยชื่อนักเขียน</Box.Title>

      <Table
        className='mb-[30px] max-h-[250px] pr-[10px]'
        bodyClassName='border-b border-gray text-[14px] font-light text-secondary hover:bg-blue-4/10'
        data={items}
        columns={[
          {
            column: 'Publisher/Writer',
            accessor: 'displayName',
            cell: ({ value }) => (
              <div className='line-clamp-1 break-all pr-[10px]'>@{value}</div>
            ),
            sortKey: OrderByEnum.DISPLAY_NAME,
            isSortable: true,
          },
          {
            column: 'จำนวนนามปากกา',
            accessor: 'totalPenName',
            cell: ({ value }) => (
              <div>{(value as number).toLocaleString()}</div>
            ),
            sortKey: OrderByEnum.TOTAL_PEN_NAME,
            isSortable: true,
            cellClassName: 'py-[10px] w-[140px] pr-[10px]',
          },
          {
            column: 'จำนวนงานเขียน',
            accessor: 'totalBook',
            cell: ({ value }) => (
              <div>{(value as number).toLocaleString()}</div>
            ),
            sortKey: OrderByEnum.TOTAL_BOOK,
            isSortable: true,
            cellClassName: 'py-[10px] w-[140px] pr-[10px]',
          },
          {
            column: 'จำนวนค้นหา',
            accessor: 'totalSearch',
            cell: ({ value }) => (
              <div>{(value as number).toLocaleString()}</div>
            ),
            sortKey: OrderByEnum.TOTAL_SEARCH,
            isSortable: true,
            cellClassName: 'py-[10px] w-[110px] pr-[10px]',
          },
          {
            column: 'Action',
            actionCell: ({ obj }) => (
              <Link
                to={`/dashboard/writer-publisher?tab=byUser&writerId=${obj.writerId}&userId=${obj.userId}`}
              >
                <button
                  className='p-[6px] rounded-[8px] border border-blue-2 text-black-970'
                  type='button'
                >
                  <EyeIcon width='18' height='18' />
                </button>
              </Link>
            ),
            isAction: true,
            cellClassName: 'w-[48px] text-right',
          },
        ]}
        initialSort={{
          key: OrderByEnum.TOTAL_SEARCH,
          order: SortingType.DESC,
        }}
        onSort={handleSortChange}
        onWaypointEnter={handleWaypointEnter}
        isLoading={isLoading}
        fixedHeader
      />
    </>
  )
}
